import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-info.tsx
/**
* icon.24.info
*
* Attention, warning, exclamation mark
*
* Keywords: information, lowercase-i, circle, help, alert, notification, warning, detail
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDVhNyA3IDAgMSAxIDAgMTQgNyA3IDAgMCAxIDAtMTRtMCAxYTYgNiAwIDEgMCAwIDEyIDYgNiAwIDAgMCAwLTEybTAgNWEuNS41IDAgMCAxIC41LjVWMTVhLjUuNSAwIDAgMS0xIDB2LTMuNWEuNS41IDAgMCAxIC41LS41bTAtMi41YS43NS43NSAwIDEgMSAwIDEuNS43NS43NSAwIDAgMSAwLTEuNSIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1960
*/
const Icon24Info = memo(function Icon24Info(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 1a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 5a.5.5 0 0 1 .5.5V15a.5.5 0 0 1-1 0v-3.5a.5.5 0 0 1 .5-.5m0-2.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
		})
	});
});
//#endregion
export { Icon24Info };

//# sourceMappingURL=icon-24-info.js.map